/* بسطة المارد — scene popups, plinth tilt, goods filters and المارد's welcome loop. Loaded by several sections; runs once. */
(function(){
  if (window.__marid) return; window.__marid = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scene: tap a garment or a brick to open its card ---------- */
  var scene = document.querySelector('[data-mh-scene]');
  if (scene) {
    var card = null, openBtn = null;
    var close = function(){
      if (card) { card.remove(); card = null; }
      if (openBtn) { if (openBtn.classList.contains('mh-bricks3d') && window.mhBricksPin) window.mhBricksPin(false); openBtn.setAttribute('aria-expanded', 'false'); openBtn = null; }
    };
    var esc = function(s){ var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
    var open = function(btn){
      var same = openBtn === btn; close(); if (same) return;
      openBtn = btn; btn.setAttribute('aria-expanded', 'true');
      var isLabna = btn.hasAttribute('data-labna'), doorTpl = btn.hasAttribute('data-door') && document.getElementById('MhDoorTpl');
      if (isLabna && window.mhBricksPin) window.mhBricksPin(true);
      var d = btn.dataset, img = btn.querySelector('img'), tpl = document.getElementById('MhBrickTpl');
      /* the stall shows a styled hero cut-out; the card shows the product's own image from Shopify (data-img) */
      var visual = isLabna ? (tpl ? tpl.innerHTML : '') : d.img ? '<img class="piece" src="' + d.img + '" alt="">' :
        (img ? '<img class="piece' + (img.classList.contains('photo') ? ' photo' : '') + '" src="' + img.currentSrc + '" alt="">' : '');
      card = document.createElement('div'); card.className = 'mh-card'; card.setAttribute('role', 'dialog'); card.setAttribute('aria-label', d.title);
      if (doorTpl) { card.className += ' mh-card--door'; card.innerHTML = '<button class="x" type="button" aria-label="إغلاق">×</button>' + doorTpl.innerHTML; }
      else card.innerHTML = '<button class="x" type="button" aria-label="إغلاق">×</button><div class="mh-stage">' + visual + '</div>' +
        '<div class="row"><h3>' + esc(d.title) + '</h3>' + (d.price ? '<span class="price mh-num">' + esc(d.price) + '</span>' : '') + '</div>' +
        '<p class="meta">' + esc(d.type) + '</p><a class="mh-btn mh-btn-primary" href="' + d.url + '">' + esc(d.cta) + '</a>';
      /* on phones the card is a bottom sheet, mounted on the page so later sections can't paint over it */
      (innerWidth > 760 ? scene : document.body).appendChild(card);
      card.querySelector('.x').onclick = close;
      if (doorTpl) fitWords(card);
      if (innerWidth > 760) {
        var r = scene.getBoundingClientRect(), br = btn.getBoundingClientRect();
        var left = br.left - r.left - 290, top = br.top - r.top - 120;
        if (left < 12) left = br.right - r.left + 16;
        top = Math.min(Math.max(70, top), r.height - (doorTpl ? card.offsetHeight + 24 : 440));
        card.style.left = left + 'px'; card.style.top = top + 'px';
      }
    };
    scene.addEventListener('click', function(e){
      var b = window.mhBricksHit && window.mhBricksHit(e.clientX, e.clientY) ? scene.querySelector('.mh-bricks3d') : e.target.closest('.mh-hang,.mh-door');
      if (b) { e.stopPropagation(); open(b); }
    });
    document.addEventListener('click', function(e){ if (card && !card.contains(e.target)) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    var lastW = innerWidth; addEventListener('resize', function(){ if (innerWidth !== lastW) { lastW = innerWidth; close(); } });

    /* the board's words are the merchant's own text: shrink them to fit the board. After the opening-day signup
       posts back, the page reloads with the result inside the template, so reopen the card to show it */
    var fitWords = function(root){
      root.querySelectorAll('.mh-door-txt span').forEach(function(el){
        el.style.fontSize = '';
        var box = el.parentNode, room = box.clientWidth;
        if (!room || !el.offsetWidth) return;
        if (el.offsetWidth > room) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * room / el.offsetWidth * .96).toFixed(2) + 'px';
      });
    };
    var doorBtn = scene.querySelector('.mh-door'), doorTpl = document.getElementById('MhDoorTpl');
    if (doorBtn) {
      var refit = function(){ fitWords(scene); };
      refit(); addEventListener('resize', refit);
      if (document.fonts) document.fonts.ready.then(refit);
      if (doorTpl && doorTpl.content.querySelector('[data-door-posted]')) open(doorBtn);
    }

    /* المارد's loop: invisible until it really plays (Low Power Mode blocks autoplay), loaded whole and played from
       memory, only for the current layout. The still painting underneath is the fallback. */
    var vids = scene.querySelectorAll('.mh-video');
    var load = function(v){
      if (v.dataset.loading || !v.offsetParent || reduce) return;
      v.dataset.loading = '1'; v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      fetch(v.dataset.src).then(function(r){ return r.blob(); }).then(function(b){
        v.src = URL.createObjectURL(b.type ? b : new Blob([b], {type: 'video/mp4'})); v.load(); tryPlay();
      }).catch(function(){ v.src = v.dataset.src; tryPlay(); });
    };
    var tryPlay = function(){ vids.forEach(function(v){ load(v); if (v.src && v.offsetParent && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } }); };
    vids.forEach(function(v){
      v.addEventListener('playing', function(){ v.classList.add('on'); });
      v.addEventListener('timeupdate', function(){ if (v.currentTime > 0.05 && !v.paused) v.classList.add('on'); });
      v.addEventListener('pause', function(){ if (!v.ended) v.classList.remove('on'); });
    });
    tryPlay();
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function(ev){ addEventListener(ev, tryPlay, {passive: true, once: true}); });
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) tryPlay(); });
    addEventListener('resize', tryPlay);
  }

  /* ---------- goods filters ---------- */
  /* type is pick-one (الكل clears it); colour toggles on and off, and turns each card to that colour's cut-out and variant */
  document.querySelectorAll('[data-mh-goods]').forEach(function(sec){
    var types = sec.querySelectorAll('.mh-chip[data-f]'), colors = sec.querySelectorAll('.mh-chip[data-c]');
    var empty = sec.querySelector('.mh-goods-empty'), f = '', c = '';
    var apply = function(){
      var shown = 0;
      sec.querySelectorAll('.mh-item').forEach(function(it){
        var has = (it.dataset.colors || '').split(' ');
        it.hidden = (!!f && it.dataset.type !== f) || (!!c && has.indexOf(c) < 0);
        if (it.hidden) return;
        shown++;
        if (!it.dataset.colors) return;
        var want = c || it.dataset.base;
        it.querySelectorAll('.piece[data-c]').forEach(function(img){ img.classList.toggle('on', img.dataset.c === want); });
        it.href = c ? it.getAttribute('data-url-' + c) : it.dataset.url;
      });
      if (empty) empty.hidden = shown > 0;
      sec.classList.add('mh-goods--filtered');
    };
    types.forEach(function(b){
      b.addEventListener('click', function(){
        f = b.dataset.f;
        types.forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
        apply();
      });
    });
    colors.forEach(function(b){
      b.addEventListener('click', function(){
        c = c === b.dataset.c ? '' : b.dataset.c;
        colors.forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.c === c); });
        apply();
      });
    });
  });

  /* ---------- touch: turn the لبنة by dragging, tap to open it ---------- */
  document.querySelectorAll('.mh-touch-brick').forEach(function(st){
    var b = st.querySelector('.mh-brick'); if (!b) return;
    var start = null, ry = -28, rx = -14, moved = false;
    function set(){ b.style.setProperty('--ry', ry + 'deg'); b.style.setProperty('--rx', rx + 'deg'); }
    st.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'mouse') return;
      start = {x: e.clientX, y: e.clientY, ry: ry, rx: rx}; moved = false;
      st.classList.remove('idle'); st.classList.add('dragging');
      /* the idle turn ends where the brick sits now, so pick up from its current angle */
      b.style.animation = 'none';
    });
    st.addEventListener('pointermove', function(e){
      if (!start) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!moved && Math.abs(dx) < 6) return;
      moved = true;
      ry = Math.max(-80, Math.min(40, start.ry + dx * .45));
      rx = Math.max(-32, Math.min(6, start.rx - dy * .15));
      set();
    });
    function end(){
      if (!start) return;
      var tap = !moved; start = null; st.classList.remove('dragging');
      if (tap && st.dataset.href) { location.href = st.dataset.href; return; }
      /* settle back to the resting angle, then resume the slow idle turn */
      ry = -28; rx = -14; set();
      clearTimeout(st._idle); st._idle = setTimeout(function(){ b.style.animation = ''; b.style.removeProperty('--ry'); b.style.removeProperty('--rx'); st.classList.add('idle'); }, 2500);
    }
    st.addEventListener('pointerup', end); st.addEventListener('pointercancel', function(){ start = null; st.classList.remove('dragging'); });
    /* mouse: hover stops the idle turn, the brick lifts and follows the pointer widely; leaving eases back to idle */
    st.addEventListener('pointerenter', function(e){
      if (e.pointerType !== 'mouse' || reduce) return;
      clearTimeout(st._idle); b.style.animation = 'none'; st.classList.remove('idle'); st.classList.add('hovering');
    });
    st.addEventListener('pointermove', function(e){
      if (e.pointerType !== 'mouse' || reduce) return;
      var r = st.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      ry = -28 + x * 70; rx = -14 - y * 26; set();
    });
    st.addEventListener('pointerleave', function(e){
      if (e.pointerType !== 'mouse' || reduce) return;
      st.classList.remove('hovering'); ry = -28; rx = -14; set();
      clearTimeout(st._idle); st._idle = setTimeout(function(){ b.style.animation = ''; b.style.removeProperty('--ry'); b.style.removeProperty('--rx'); st.classList.add('idle'); }, 900);
    });
    if (st.dataset.href) st.addEventListener('click', function(e){ if (matchMedia('(hover: hover)').matches) location.href = st.dataset.href; });
  });

  /* ---------- لبنة quantity: stepper with no upper limit; the button's total in the store's money format ---------- */
  var money = function(cents, format){
    var n = cents / 100, fix = function(d, th, dec){ var s = n.toFixed(d).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (s[1] ? dec + s[1] : ''); };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      return k === 'amount_no_decimals' ? fix(0, ',', '.') : k === 'amount_with_comma_separator' ? fix(2, '.', ',')
        : k === 'amount_no_decimals_with_comma_separator' ? fix(0, '.', ',') : k === 'amount_with_apostrophe_separator' ? fix(2, "'", '.') : fix(2, ',', '.');
    });
  };
  document.querySelectorAll('[data-mh-qty]').forEach(function(box){
    var input = box.querySelector('input'), unit = +box.dataset.unit, format = box.dataset.format || '{{amount}}';
    var total = box.closest('form').querySelector('[data-mh-total]'), less = box.querySelector('[data-step="-1"]');
    var set = function(n){
      n = Math.max(1, parseInt(n, 10) || 1); input.value = n;
      if (total) total.textContent = money(unit * n, format);
      less.disabled = n <= 1;
    };
    box.querySelectorAll('[data-step]').forEach(function(b){ b.onclick = function(){ set((parseInt(input.value, 10) || 1) + +b.dataset.step); }; });
    input.addEventListener('change', function(){ set(input.value); });
    set(input.value);
  });

  /* ---------- plinth tilt ---------- */
  if (!reduce && matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function(e){
      var st = e.target.closest && e.target.closest('.mh-tilt'); if (!st || st.classList.contains('mh-touch-brick')) return;
      var r = st.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      var t = st.querySelector('.piece.on,.mh-brick') || st.querySelector('.piece'); if (!t) return;
      if (t.classList.contains('mh-brick')) { t.style.setProperty('--ry', (-28 + x * 50) + 'deg'); t.style.setProperty('--rx', (-14 - y * 20) + 'deg'); }
      else { t.style.setProperty('--py', (x * 18) + 'deg'); t.style.setProperty('--px', (-y * 12) + 'deg'); }
    });
    document.addEventListener('pointerout', function(e){
      var st = e.target.closest && e.target.closest('.mh-tilt'); if (!st || st.contains(e.relatedTarget)) return;
      st.querySelectorAll('.piece,.mh-brick').forEach(function(t){ ['--ry', '--rx', '--py', '--px'].forEach(function(v){ t.style.removeProperty(v); }); });
    });
  }
})();
